// content.jsx
// Page Router - handles routing and global modals
// Header/Footer are now handled by LayoutEngine via schema

import React, { Suspense } from "react";
import {
	Route,
	withRouter,
	Switch,
	Redirect,
} from "react-router-dom";
import { 
	fetchRoute, 
} from "../../config/page-route.jsx";
import { PageSettings } from "../../config/page-settings.js";
import { connect } from "react-redux";
import Footer from "components/template_1/Footer.js";
import Header from "components/template_1/Header.js";
import reactManifest from "react-manifest";
import manifest from "../../manifest.json";
import LoadingPlaceholder from "components/template_1/LoadingPlaceholder.js";
// import LoadingPlaceholder from "components/blocks/LoadingPlaceholder";
import { find, includes } from "lodash";

import {
	WebUrl,
} from "../../util/Constant";
import { isValidLocale, hasValidLocale, extractLocaleFromPathname } from "../../util/Util.js";
import NotFound from "pages/template_1/NotFound.js";

// Moved to individual header skins (HeaderGembet.js and HeaderRiocity.js)
// // v1
// import ReportOverviewModal from "../../pages/template_1/report/ReportsOverview.js";
// import DailyCheckInModal from "components/template_1/DailyCheckInModal.js";
// import ReferralBonusModal from "components/template_1/ReferralBonusModal";
// import MyProfileModal from "components/template_1/MyProfileModal";
// import CompleteInfoModal from "components/template_1/CompleteInfoModal.js";
// import SuccessRegister from "pages/template_1/SuccessRegister.js";
// import DepositWithdrawalModal from "components/template_1/DepositWithdrawalModal.js";
// import DownlineModal from "components/template_1/DownlineModal.js";
// import ShareReferralModal from "components/template_1/ShareReferralModal.js";
// // import RegisterModal from "components/template_1/RegisterModal.js";
// // import ResetPasswordModal from "components/template_1/ResetPasswordModal.js";
// // import LoginModal from "components/template_1/LoginModal.js";

// //v2 
// import LoginModal from "components/themesystem/gembet/LoginModal.js";
// import ResetPasswordModal from "components/themesystem/gembet/ResetPasswordModal.js";
// import RegisterModal from "components/themesystem/gembet/RegisterModal.js";

import { SchemaContext } from "../../theme-system/SchemaContext";
import { RenderComponents } from "../../theme-system/LayoutEngine";

/**
 * Hostname-based dev/staging-style flag: localhost, loopback, or riocity9.com (+ subdomains).
 * (Not NODE_ENV; use for gated console diagnostics only.)
 */
function isDevOrStagingHost() {
	if (typeof window === 'undefined') return false;
	const h = window.location.hostname;
	return (
		// h === 'localhost' ||
		h === '127.0.0.1' ||
		h === 'riocity9.com' ||
		h.endsWith('.riocity9.com')
	);
}

function getSchemaViewComponents(schema, viewKey) {
	const view = schema?.views?.[viewKey];
	if (!view) return null;
	if (viewKey === 'home' && Array.isArray(view.section)) {
		return view.section;
	}
	return view.components;
}

class Content extends React.Component {
	constructor(props) {
		super(props);
		this._TIMEOUT_TIME = 60 * 60 * 1000;
		this._isMounted = false;
		this.state = {
			template: props.template ?? "template_1",
			routes: null,
			currroutes: null,
			loginRoute: null,
			currentPage: this.props.history.location.pathname,
			bottomNavIndex: 0,
		};
	}

	ComponentRoute(routeComponent) {
		return routeComponent;
	}

	PrivateRoute(index, routeData) {
		const isLoggedIn = this.props.authState.heartBeat;
		const shouldRedirect = routeData.authRequired && !isLoggedIn;

		const { pathname, state } = this.props.history.location;

		if (hasValidLocale(pathname)) {
			const routeLocale = extractLocaleFromPathname(pathname);
			const selectedLocale = localStorage.getItem("userSelectedLanguageCode");

			if (selectedLocale && selectedLocale !== routeLocale) {
				const currentReference = state?.reference;
				const currentNavRef = state?.navRef;
				const nextPathname = pathname.replace(
					new RegExp(`^/${routeLocale}(/|$)`),
					`/${selectedLocale}$1`
				);

				return (
					<Route
						key={index}
						path={pathname}
						exact={true}
						render={(props) => {
							return <Redirect to={{
								pathname: nextPathname,
								search: props.location.search,
								hash: props.location.hash,
								state: { from: props.location, reference: currentReference, navRef: currentNavRef }
							}} />
						}}
					/>
				);
			}

			WebUrl.setCurrentLocale(routeLocale);
		} else {
			const currentReference = state?.reference;
			const currentNavRef = state?.navRef;
			const currentLocale = WebUrl.getCurrentLocale();
			const regex = new RegExp(`^/${currentLocale}(/|$)`);
			const locationPathname = pathname.replace(regex, '/');
			const redirectPath = WebUrl.getLocaleUrl(locationPathname);

			return (
				<Route
					key={index}
					path={pathname}
					exact={true}
					render={(props) => {
						return <Redirect to={{
							pathname: redirectPath,
							search: props.location.search,
							hash: props.location.hash,
							state: { from: props.location, reference: currentReference, navRef: currentNavRef }
						}} />
					}}
				/>
			);
		}

		return (
			<Route
				key={index}
				path={shouldRedirect ? this.state.loginRoute.path: routeData.path}
				exact={shouldRedirect ? this.state.loginRoute.exact : routeData.exact}
				render={(props) => {
					if (shouldRedirect) {
						return <Redirect to={{
							pathname: this.state.loginRoute.path,
							search: props.location.search,
							hash: props.location.hash,
							state: { from: props.location }
						}} />
					} else {
						return (
							<SchemaContext.Consumer>
								{({ schema }) => {
									const viewKey = routeData.viewKey || 'home';
									const schemaComponents = getSchemaViewComponents(schema, viewKey);
									const routeComponent = this.ComponentRoute(routeData.component);
									// Login powers both home + register; register must get schema or Custom Grid stays V1 (no Netflix ranks).
									const useLoginWithSchema =
										(viewKey === 'home' || viewKey === 'register') &&
										React.isValidElement(routeComponent);

									if (!schemaComponents && isDevOrStagingHost()) {
										// console.log(
										// 	'[Content] No schema components for viewKey:',
										// 	viewKey,
										// 	'- falling back to page-route component (routeData.component).'
										// );
									}

									return (
										<Suspense fallback={<LoadingPlaceholder />}>
											{schemaComponents || (useLoginWithSchema && schema) ? (
												useLoginWithSchema && (viewKey === 'home' || !schemaComponents) ? (
													React.cloneElement(routeComponent, {
														viewKey,
														// Keep register schemaComponents null so Login stays on renderLegacyDashboard (home section would hit RenderComponents).
														schemaComponents: schemaComponents || null,
														schema
													})
												) : (
													<RenderComponents name={viewKey} data={schemaComponents} />
												)
                                            ) : (
                                                isDevOrStagingHost() &&
                                                    console.log(
                                                        '[Content] No schema components for viewKey:',
                                                        viewKey,
                                                        '- falling back to page-route component (routeData.component).'
                                                    ),
                                                routeComponent
                                            )}
											{/* {React.cloneElement(this.ComponentRoute(routeData.component), {
												viewKey: routeData.viewKey,
												schemaComponents: schemaComponents || null
											})} */}
										</Suspense>
									);
								}}
							</SchemaContext.Consumer>
						);
					}
				}}
			/>
		);
	}

	componentWillUpdate() {
		if (this.currentPage !== this.props.history.location.pathname) {
			this.currentPage = this.props.history.location.pathname;
			this.resetTimeout();
		}
	}

	async loadData() {
		try {
			// TODO: In future, routes could also come from schema
			const loginRouteVar = await fetchRoute("login");
			const routesVar = await fetchRoute("all");

			if (this._isMounted) {
				this.setState({
					routes: routesVar,
					loginRoute: loginRouteVar,
					currroutes: null,
				});
			}
			// Now you can work with the data
		} catch (error) {
			console.error('[Content] Error loading routes:', error);
		}
	}

	componentDidMount() {
		this._isMounted = true;
		const { dispatch } = this.props;

		this.loadData();
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	componentWillMount() {
	}

	resetTimeout = () => {
		clearTimeout(this.startTimeout);

		if (this.state.template == "template_1") {
			if (
				this.currentPage !== "/" &&
				this.props.history.location.pathname !== "/"
			) {
				this.startTimeout = setTimeout(() => {
					window.location.reload();
				}, this._TIMEOUT_TIME);
			}
		}
	};

	render() {
		// if (this.state.routes == null) return false;
		// this.state.currroutes = this.state.routes.filter((route) => {
		// 	return route.path == this.props.history.location.pathname;
		// });

		if (this.state.routes == null) return false;

		// Optimization - Filter through routes to eliminate non-matching routes
		this.state.currroutes = this.state.routes.filter((route) => {
			let pathname = route.path;
			let currRoutePath = this.props.history.location.pathname;

			const hotGameWebUrl = WebUrl._URL_HOT_GAMES;
			const hotProviderWebUrl=WebUrl._URL_HOT_PROVIDERS;

			 // Remove leading and trailing slashes for easier comparison
			const normalizedPathname = pathname.replace(/^\/|\/$/g, '');
			const normalizedCurrRoutePath = currRoutePath.replace(/^\/|\/$/g, '');
			const normalizedHotGameUrl = hotGameWebUrl.replace(/^\/|\/$/g, '');
			const normalizedHotproviderUrl = hotProviderWebUrl.replace(/^\/|\/$/g, '');

		
			// Split paths into segments
			const routeSegments = normalizedPathname.split('/');
			const pathSegments = normalizedCurrRoutePath.split('/');
			const hotGameSegments = normalizedHotGameUrl.split('/');
			const hotProviderSegments = normalizedHotproviderUrl.split('/');
			
			// Check if HotGame is enabled
			if(!this.props.appState.isHotGameEnabled) {
				const rebuiltPath = pathSegments.slice(1).join('/');
				const hotGameUrl = hotGameSegments.slice(1).join('/');
				if(rebuiltPath === hotGameUrl){
					return false;
				}
			}

		    // Check if HotProvider is enabled
			if(!this.props.appState.isHotProviderEnabled) {
				const rebuiltPath = pathSegments.slice(1).join('/');
				const hotProviderUrl =hotProviderSegments.slice(1).join('/');
				if(rebuiltPath === hotProviderUrl){
					return false;
				}
			}
		
			// Check for exact matches for non-parameterized routes
			if (route.exact && normalizedPathname === normalizedCurrRoutePath) {
				return true;
			}
		
			// Check for locale parameterized routes
			if (pathname.includes(':locale')) {
				const localeSegment = pathSegments[0]; // Assuming the locale is the first segment
				if (isValidLocale(localeSegment)) {
					// Rebuild the path without the locale for further matching
					const rebuiltPath = pathSegments.slice(1).join('/');
					const rebuiltRoutePath = routeSegments.slice(1).join('/');
					if (rebuiltPath === rebuiltRoutePath || pathname.endsWith(':slug')) {
						return true;
					}
				}
			}
		
			// Handling other parameterized routes that might contain slugs
			if (!route.exact && pathname.includes(':slug')) {
				return true; // Placeholder logic; refine this based on actual route structure
			}

			return false;
		});

		return (
			<PageSettings.Consumer>
				{({
					pageContentFullWidth,
					pageContentClass,
					pageContentInverseMode,
				}) => (
					<div className="page-content-wrapper">
						<div
							className={
								"content " +
								(pageContentFullWidth ? "content-full-width " : "") +
								(pageContentInverseMode ? "content-inverse-mode " : "") +
								pageContentClass
							}
						>
							{/* <Header /> */}

							{/* BrowserRouter located in index.js */}
							{/* Routes - page content */}
							<Switch>
								{this.state.currroutes.map((route, index) => {
									return this.PrivateRoute(index, route);
								})}
								{/* Catch all undefined routes */}
								<Route component={NotFound} />
							</Switch>

							{/* <DailyCheckInModal />
							<DepositWithdrawalModal />
							<DownlineModal />
							<ReportOverviewModal />
							<ShareReferralModal />
							<LoginModal />
							<RegisterModal />
							<ResetPasswordModal />
							<ReferralBonusModal />
							<MyProfileModal popout={false} />
							<CompleteInfoModal /> */}

							{/* <Footer /> */}
						</div>
					</div>
				)}
			</PageSettings.Consumer>
		);
	}
}

const mapStateToProps = (state) => ({
	...state,
});

export default connect(mapStateToProps, null)(withRouter(Content));
